module.exports = __webpack_public_path__ + "89450cf5cc6a10443bb58e5387678b37.png";